// CSS 가져오기
// import '../styles/admin/addCss.css';
import '../../styles/admin/admin.css';
import '../../styles/admin/adminHeader.css';
import '../../styles/admin/common.css';
import '../../styles/admin/popUp.css';
import '../../styles/admin/reset.css';
import '../../styles/admin/style.css';

import AdminLogin from '../../components/admin/login/AdminLogin';

export default function Admin() {
  return (
    <>
      <AdminLogin></AdminLogin>
    </>
  );
}
